import React from 'react';

import { Moment } from 'moment';

import { stateCityOptionalStepProvider } from '../../employees/city-state-provider';

import { MessageType } from '../../util/message-types';
import { SingleLanguageComposerWithPlugins } from '../../widgets/message-composer/wrappers/single-language-composer-with-plugins';

export type SendMessageMethod = (
  message: string,
  type: string,
  subject?: string | null,
  sendDateTime?: Moment | null,
  optionalFields?: {
    urlFileMappings?: Record<string, string>;
    sendWithVCard?: boolean;
  },
) => Promise<any>;

type EmployeeMessageComposerProps = {
  activeEmployee?: Employee;
  message: string | null;
  enableText: boolean;
  enableEmail: boolean;
  handleTemplateSelect: (message: string) => void;
  handleSendMessageToContact?: (contactId: number) => SendMessageMethod;
  handleSendMessage?: SendMessageMethod;
  onMessageTypeChange: (messageType: MessageType) => void;
  orgId: number;
  onClose: Function;
  initialType?: MessageType;
  subject?: string;
  onSubjectChange?: (subject: string) => void;
  clearDraft?: () => void;
  handleToggleTemplateDialog?: () => void;
};

const WrapperComponent = (props: EmployeeMessageComposerProps) => {
  const {
    activeEmployee,
    message,
    enableText,
    enableEmail,
    handleTemplateSelect,
    handleSendMessageToContact,
    handleSendMessage,
    onMessageTypeChange,
    orgId,
    initialType,
    subject,
    onSubjectChange,
    clearDraft,
    handleToggleTemplateDialog,
  } = props;

  const onSend =
    handleSendMessageToContact && activeEmployee
      ? handleSendMessageToContact(activeEmployee.contactId)
      : handleSendMessage;
  if (!onSend) {
    throw new Error(
      'Missing onSend method, please provide either handleSendMessage or handleSendMessageToContact',
    );
  }

  return (
    <SingleLanguageComposerWithPlugins
      orgId={orgId}
      message={message}
      enableText={enableText}
      enableEmail={enableEmail}
      autofocus
      onSendMessage={onSend}
      onMessageTypeChange={onMessageTypeChange}
      onChange={handleTemplateSelect}
      handleToggleTemplateDialog={handleToggleTemplateDialog}
      initialType={initialType}
      subject={subject}
      onSubjectChange={onSubjectChange}
      clearDraft={clearDraft}
      canScheduleMessageInFuture
      allowSendWithVCard
    />
  );
};

export const EmployeeMessageComposer: React.ComponentType<EmployeeMessageComposerProps> =
  stateCityOptionalStepProvider<EmployeeMessageComposerProps>(
    (o) => o.phoneNumber,
    WrapperComponent,
  ) as any;
